import { MenuItem, Modal, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    closeMakeAiPopup,
    openMakeAiPopup,
    selectMakeAiPopupOpen,
} from "@/nav/navSlice";
import AiChat from "./AiChat";

export default function AiChatPopup() {
    const open = useSelector(selectMakeAiPopupOpen);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(closeMakeAiPopup());
    };
    return (
        <>
            <Modal
                keepMounted={false}
                open={open || false}
                onClose={handleClose}
            >
                <>
                    <AiChat />
                </>
            </Modal>
        </>
    );
}
